import script from "./clientAPI.vue?vue&type=script&lang=js"
export * from "./clientAPI.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__